import { UnorderedListOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'

import ItemsWithLoading from '@/components/Atoms/ItemsWithLoading/ItemsWithLoading'
import ConstructionSiteCard from '@/components/ConstructionSites/ConstructionSiteCard/ConstructionSiteCard'
import OrganisationBar from '@/components/OrganisationBar/OrganisationBar'
import useConstructionSites from '@/hooks/constructionSites/useConstructionSites'
import { useProfileStore } from '@/stores/user/profileStore'
import { ConstructionSiteInterface } from '@/types'

import cn from './ConstructionSitesArchive.module.scss'

function ConstructionSitesArchive() {
  const [constructionSitesLoading, setConstructionSitesLoading] =
    useState(false)
  const [fetchingError] = useState<string>('')

  const { constructionSites, updateConstructionSites, setConstructionSites } =
    useProfileStore((state) => state)

  const getConstructionSites = useConstructionSites({
    setConstructionSitesLoading,
    setConstructionSites,
  })

  const [, contextHolder] = Modal.useModal()

  // 1. Исправлена ошибка Promise (добавлен .then)
  useEffect(() => {
    if (updateConstructionSites) {
      getConstructionSites().then((result) => {
        if (!result) return

        if (result.status === 'success') {
          toast.success(result.message)
        } else if (result.status === 'error') {
          toast.error(result.message)
        } else if (result.status === 'warning') {
          toast.warning(result.message)
        } else {
          toast.info(result.message)
        }
      })
    }
  }, [getConstructionSites, updateConstructionSites])

  // Первичная загрузка
  useEffect(() => {
    getConstructionSites()
  }, [getConstructionSites])

  return (
    <>
      {contextHolder}

      <section className={cn.archive}>
        <OrganisationBar />

        <div className={cn.headerBlock}>
          <h2 className={cn.pageTitle}>Архив</h2>
          <Link to="/construction-sites">
            <Button icon={<UnorderedListOutlined />} type="default">
              Активные объекты
            </Button>
          </Link>
        </div>

        <ItemsWithLoading
          items={constructionSites.filter(
            (constructionSite) => !constructionSite.isActive
          )}
          loading={constructionSitesLoading}
          empty={
            <div className={cn.emptyMessage}>
              <span>В архиве пусто</span>
            </div>
          }
          error={<></>}
          loadingError={fetchingError}
          loaderPaddingTop={96}
        >
          <div className={cn.list}>
            {constructionSites
              .filter((constructionSite) => !constructionSite.isActive)
              .map(
                (
                  constructionSite: ConstructionSiteInterface['constructionSiteModel']
                ) => (
                  <ConstructionSiteCard
                    constructionSite={constructionSite}
                    location="constructionSitesArchive"
                    key={constructionSite.id}
                  />
                )
              )}
          </div>
        </ItemsWithLoading>
      </section>
    </>
  )
}

export default ConstructionSitesArchive
